import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { lists as listsApi } from 'redux/modules/api'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api }) => ({
        lists: api.lists
      }),
      { ...listsApi }
    )
    class Lists extends Component {
      static propTypes = {
        getTransportationModeList: PropTypes.object.isRequired
      }

      componentDidMount() {
        config.transportationMode && this.handleGetTransportationModeList()
      }
      handleGetTransportationModeList = () => {
        return this.props.getTransportationModeList()
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            getTransportationModeList={this.handleGetTransportationModeList}
          />
        )
      }
    }
    return Lists
  }
}

export default decorator
